import { createApi } from '@reduxjs/toolkit/query/react';
import apiBaseQuery from './axiosBaseQuery'
export const EMISSIONS_API_REDUCER_KEY = 'emissionsApi';


export const emissionsApi = createApi({
    reducerPath: EMISSIONS_API_REDUCER_KEY,
    baseQuery: apiBaseQuery,
    tagTypes: ['emissions'],
    endpoints: (builder) => ({
        getAllEmissions: builder.query({
            query: ({ page, q, country, limit }) => ({
                url: `admin/repository/emissions?page=${page}&q=${q}&country=${country}&limit=${limit}`
            }),
            providesTags: ['emissions']
        }),
        getEmissions: builder.query({
            query: (id) => ({
                url: `admin/repository/emissions/${id}`
            }),
            providesTags: ['emissions']
        }),
        createEmissions: builder.mutation({
            query: (body) => ({
                url: `admin/repository/emissions`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['emissions']
        }),
        updateEmissions: builder.mutation({
            query: ({ id, ...rest }) => ({
                url: `admin/repository/emissions/${id}`,
                method: 'PUT',
                body: rest,
            }),
            invalidatesTags: ['emissions']
        }),
    })
});

export const {
    useGetAllEmissionsQuery,
    useGetEmissionsQuery,
    useCreateEmissionsMutation,
    useUpdateEmissionsMutation,
} = emissionsApi;